import { usePayseraSigningPollLazyQuery } from 'api/core/generated';
import {
  APP_POLLING_INTERVALS,
  AppApiVersions,
  LocalStorageKeys,
} from 'app-constants';
import { getFromStorage } from 'services';

export const useBanklinkSigningPoll = () => {
  const [
    pollBanklinkSigningStatus,
    { data: pollData, loading: pollLoading, error: pollError, stopPolling },
  ] = usePayseraSigningPollLazyQuery({
    context: { apiVersion: AppApiVersions.core },
    pollInterval: APP_POLLING_INTERVALS.default,
  });

  const startBanklinkSigningStatusPolling = () => {
    const session_id = getFromStorage(LocalStorageKeys.sessionId) ?? '';
    return pollBanklinkSigningStatus({ variables: { session_id } });
  };

  return {
    startBanklinkSigningStatusPolling,
    stopBanklinkSigningStatusPolling: stopPolling,
    isBanklinkSigningPollSuccess: Boolean(pollData?.success),
    banklinkSigningPollLoading: pollLoading,
    banklinkSigningPollError: pollError,
  };
};
